var map = {
	"./AR.svg": 39295,
	"./BO.svg": 92611,
	"./CL.svg": 70899,
	"./CO.svg": 26240,
	"./CR.svg": 87637,
	"./DO.svg": 11833,
	"./EC.svg": 28730,
	"./GU.svg": 94430,
	"./MX.svg": 66937,
	"./PA.svg": 11939,
	"./PE.svg": 20783,
	"./PR.svg": 96512,
	"./PY.svg": 10251,
	"./SV.svg": 20361,
	"./UY.svg": 57312,
	"./VE.svg": 24685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22256;